'use strict';
'use client';
import { j as t } from "../../external/react/jsx-runtime.js";
import { FontAwesomeIcon as a } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faImage as q, faPaperclip as J, faSpinnerThird as Q, faTriangleExclamation as Z } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { faPaperPlane as A } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { forwardRef as C, useState as ee } from "react";
import m from "../../external/classnames/index.js";
import { useTheme as te } from "../Provider/index.js";
const le = 8, ue = C(
  ({
    placeholder: g = "Enter text here...",
    type: n = "text",
    id: f,
    name: o,
    label: h,
    prefix: j,
    leftIcon: v,
    rightIcon: y,
    onclickIcon: N,
    isLoading: T,
    error: p,
    helperText: Y,
    disabled: s,
    required: z,
    showFeedback: K = !0,
    capitalise: P,
    onChange: l,
    chat: c,
    textArea: b,
    onAttachFile: w,
    onAttachImage: D,
    onSubmit: k,
    className: R,
    dob: u,
    ...M
  }, V) => {
    const { isMosh: B, isMoshy: I } = te(), [i, x] = ee(""), W = m(
      "relative flex items-start rounded-lg transition-all duration-200 px-4 py-3 bg-white gap-2 grow",
      {
        "hover:outline-2 hover:bg-grey-100 outline outline-1 outline-grey-300 bg-white": !s,
        "bg-grey-100 cursor-not-allowed shadow-none outline-none border-none": s,
        "focus-within:outline-2 focus-within:outline-blue": !s && !p,
        "outline-2 outline-red-error focus-within:outline-red-error": p,
        "py-0 px-0": n === "number"
      }
    ), $ = m(
      "flex-1 bg-transparent w-full text-black resize-none",
      "placeholder-grey-300 outline-none border-none",
      "disabled:text-grey-400 disabled:cursor-not-allowed",
      {
        "min-h-[100px]": b
      },
      n === "number" && "[&::-webkit-outer-spin-button]:appearance-none",
      n === "number" && "[&::-webkit-inner-spin-button]:appearance-none",
      n === "number" && "[-moz-appearance:textfield]",
      R
    ), _ = (e) => {
      l == null || l(e), e.target.value === "" ? e.target.style.height = "auto" : e.target.style.height = `${Math.min(e.target.scrollHeight, 154)}px`;
    }, E = (e) => {
      e.preventDefault(), k && i.trim() && (k(i), x(""));
    }, G = (e) => {
      c && e.key === "Enter" && !e.shiftKey && E(e);
    }, H = (e) => {
      let r = e;
      return e.length >= 2 && (r = `${e.slice(0, 2)}/${e.slice(2)}`), e.length >= 4 && (r = `${e.slice(0, 2)}/${e.slice(2, 4)}/${e.slice(4)}`), r;
    }, L = (e) => {
      const r = e.target.value, F = i, O = r.length < F.length;
      let d = r.replace(/\D/g, "");
      O && F.endsWith("/") && !r.endsWith("/") && (d = d.slice(0, -1));
      const U = d.slice(0, le), S = H(U), X = {
        ...e,
        target: { ...e.target, value: S }
      };
      x(S), l == null || l(X);
    };
    return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-1", children: [
      h ? /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ t.jsx(
          "label",
          {
            htmlFor: f || o,
            className: "text-sm font-bold text-grey-400",
            children: /* @__PURE__ */ t.jsx("small", { children: h })
          }
        ),
        z ? /* @__PURE__ */ t.jsx("span", { className: "text-red-error pl-1", children: "*" }) : null
      ] }) : null,
      /* @__PURE__ */ t.jsxs("div", { className: "flex flex-row items-start gap-1", children: [
        /* @__PURE__ */ t.jsxs("div", { className: W, children: [
          j ? /* @__PURE__ */ t.jsx("span", { className: "pl-4 pr-4 mr-2 py-3 border-r border-grey-300 font-demi text-grey-400", children: j }) : null,
          v ? /* @__PURE__ */ t.jsx(
            a,
            {
              icon: v,
              className: "text-grey-300 mt-1",
              onClick: N
            }
          ) : null,
          c || b ? /* @__PURE__ */ t.jsx(
            "textarea",
            {
              className: $,
              ref: V,
              id: f || o,
              name: o,
              value: i,
              placeholder: g,
              disabled: s,
              rows: 1,
              onChange: (e) => {
                c && _(e), l == null || l(e), x(e.target.value);
              },
              onKeyDown: (e) => {
                c && G(e);
              },
              ...M
            }
          ) : /* @__PURE__ */ t.jsx(
            "input",
            {
              className: $,
              ref: V,
              type: u ? "text" : n,
              id: f || o,
              name: o,
              placeholder: u ? "DD/MM/YYYY" : g,
              disabled: s,
              maxLength: u ? 10 : void 0,
              value: u ? i : void 0,
              onChange: (e) => {
                u ? L(e) : P ? (e.target.value = e.target.value.toUpperCase(), l == null || l(e), x(e.target.value)) : (l == null || l(e), x(e.target.value));
              },
              ...M
            }
          ),
          /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col -mt-1", children: [
            D ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsx(
                "label",
                {
                  htmlFor: "attach-image",
                  className: m(
                    "text-grey-400 p-1 pt-0",
                    {
                      "cursor-pointer": !s
                    }
                  ),
                  children: /* @__PURE__ */ t.jsx(a, { icon: q })
                }
              ),
              /* @__PURE__ */ t.jsx(
                "input",
                {
                  id: "attach-image",
                  disabled: s,
                  type: "file",
                  accept: "image/png, image/jpg, image/jpeg",
                  hidden: !0,
                  onChange: (e) => {
                    var r;
                    (r = e == null ? void 0 : e.target) != null && r.files && D(
                      e.target.files[0]
                    );
                  }
                }
              )
            ] }) : null,
            w ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsx(
                "label",
                {
                  htmlFor: "attach-file",
                  className: m(
                    "text-grey-400 p-1 pt-0",
                    {
                      "cursor-pointer": !s
                    }
                  ),
                  children: /* @__PURE__ */ t.jsx(a, { icon: J })
                }
              ),
              /* @__PURE__ */ t.jsx(
                "input",
                {
                  id: "attach-file",
                  disabled: s,
                  type: "file",
                  accept: ".pdf, .txt, .doc, .docx",
                  hidden: !0,
                  onChange: (e) => {
                    var r;
                    (r = e == null ? void 0 : e.target) != null && r.files && w(e.target.files[0]);
                  }
                }
              )
            ] }) : null
          ] }),
          y ? /* @__PURE__ */ t.jsx(
            a,
            {
              icon: y,
              className: "text-grey-300 mt-1",
              onClick: N
            }
          ) : null,
          T ? /* @__PURE__ */ t.jsx(
            a,
            {
              icon: Q,
              spin: !0,
              className: "text-grey-300 mt-1"
            }
          ) : null
        ] }),
        c ? /* @__PURE__ */ t.jsx(
          "button",
          {
            "aria-label": "Send",
            disabled: i.length === 0 || s,
            type: "submit",
            onClick: E,
            className: m(
              " disabled:text-grey-300 p-1 mt-1",
              {
                "text-green-dark hover:text-green-faint-dark": B,
                "text-blue-dark hover:text-blue-light": I,
                "text-grey-300": s
              }
            ),
            children: /* @__PURE__ */ t.jsx(a, { icon: A })
          }
        ) : null
      ] }),
      K ? /* @__PURE__ */ t.jsx("div", { className: "flex items-center gap-2 text-sm h-5", children: p ? /* @__PURE__ */ t.jsxs("span", { className: "text-red-error space-x-2", children: [
        /* @__PURE__ */ t.jsx(a, { icon: Z }),
        /* @__PURE__ */ t.jsx("span", { children: p })
      ] }) : /* @__PURE__ */ t.jsx("span", { className: "text-grey-400", children: Y }) }) : null
    ] });
  }
);
export {
  ue as default
};
